export const MODAL_ANI_TYPES = {
  flipDown: "flip-down",
  bottomFadeIn: "bottom-fade-in"
};
export const modalAnimations = {
  [MODAL_ANI_TYPES.flipDown]: {
    style: {
      originX: 0,
      originY: "100%"
    },
    variants: {
      start: { scale: 2, x: -100, rotate: -30, opacity: 0 },
      visible: { scale: 1, x: 0, rotate: 0, opacity: 1, transition: { duration: 0.3 } },
      exit: { scale: 2, x: -100, rotate: -30, opacity: 0, transition: { duration: 0.15 } }
    }
  },
  [MODAL_ANI_TYPES.bottomFadeIn]: {
    style: {
      originX: 0,
      originY: "100%"
    },
    variants: {
      start: { y: 100, rotate: 0, opacity: 0 },
      visible: { y: 0, rotate: 0, opacity: 1, transition: { duration: 0.3 } },
      exit: { y: -100, rotate: 0, opacity: 0, transition: { duration: 0.15 } }
    }
  }
};
